import { useEffect, useState } from "react";
import { PageHeader } from "../../components/common/PageHeader";
import { DataTable } from "../../components/common/DataTable";
import { AuditService } from "../../services";
import { dateTime } from "../../utils/format";

export const AuditLogsPage = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { AuditService.list().then(setRows).finally(() => setLoading(false)); }, []);
  return (
    <div>
      <PageHeader title="Audit Logs" subtitle="Important actions performed in the system." />
      <DataTable
        loading={loading}
        rows={rows.map((r) => ({ ...r, key: r.auditId }))}
        empty="No audit entries yet."
        testId="audit-table"
        searchable
        searchKeys={["fullName", "username", "actionType", "moduleName", "recordId", "reason", "newValue", "oldValue"]}
        searchPlaceholder="Search audit by user, action, module or detail…"
        columns={[
          { key: "createdAt", header: "When", render: (r) => dateTime(r.createdAt) },
          { key: "user", header: "User", render: (r) => r.fullName || r.username || "System / Unknown" },
          { key: "actionType", header: "Action" },
          { key: "moduleName", header: "Module" },
          { key: "recordId", header: "Record" },
         { key: "detail", header: "Detail", render: (r) => r.reason || r.newValue || r.oldValue || "—" },
        ]}
      />
    </div>
  );
};
